module.exports = __webpack_public_path__ + "img/mobile-form-2.b1e85443.png";